import { DESKTOP_MIN_WIDTH } from 'constants';
import React from 'react';
import styled from 'styled-components';

const OuterFitHeight = ({
  children,
  isCenter = false,
  maxHeight = '100dvh',
}) => {
  return (
    <OuterFitHeightStyled $isCenter={isCenter} $maxHeight={maxHeight}>
      {children}
    </OuterFitHeightStyled>
  );
};

const OuterFitHeightStyled = styled.div`
  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    height: fit-content;
  }

  ${(props) =>
    props.$maxHeight &&
    `
  height: calc(${props.$maxHeight} - 70px);
  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    min-height: calc(${props.$maxHeight} - 72px - 24px - 47px);
  }
  `}

  ${(props) =>
    props.$isCenter &&
    `
    display: flex;
    align-items: center;
    justify-content: center;
  `}
`;

export default OuterFitHeight;
